export function createDefaultWorkHours() {
    return {
        monday: { start: '08:00', end: '22:00' },
        tuesday: { start: '08:00', end: '22:00' },
        wednesday: { start: '08:00', end: '22:00' },
        thursday: { start: '08:00', end: '22:00' },
        friday: { start: '08:00', end: '22:00' },
        saturday: { start: '08:00', end: '22:00' },
        sunday: { start: '10:00', end: '24:00' },
    };
}
export function createDefaultEnergyPatterns() {
    const weekdayPattern = [
        { start: '08:00', end: '12:00', level: 'high' },
        { start: '12:00', end: '17:00', level: 'medium' },
        { start: '17:00', end: '22:00', level: 'high' },
    ];
    const sundayPattern = [
        { start: '10:00', end: '15:00', level: 'medium' },
        { start: '15:00', end: '20:00', level: 'medium' },
        { start: '20:00', end: '24:00', level: 'low' },
    ];
    return {
        monday: [...weekdayPattern],
        tuesday: [...weekdayPattern],
        wednesday: [...weekdayPattern],
        thursday: [...weekdayPattern],
        friday: [...weekdayPattern],
        saturday: [...weekdayPattern],
        sunday: sundayPattern,
    };
}
export function createDefaultTaskDefaults() {
    return {
        min_duration: 15,
        default_duration: 60,
        buffer_percentage: 10,
    };
}
export function createDefaultSchedulingPreferences() {
    return {
        batch_similar_tasks: true,
        auto_reschedule_daily: true,
        days_to_schedule_ahead: 7,
        respect_energy_patterns: true,
        energy_match_bonus: 0.15,
        max_deep_work_stretch: 120,
    };
}
export function createDefaultDisplayPreferences() {
    return {
        time_format: '24h',
        date_format: 'YYYY-MM-DD',
        color_scheme: 'dark',
        show_completed_tasks: false,
    };
}
/**
 * The IANA zone this device is in, or undefined if it cannot be determined.
 *
 * `Intl` is standard JS and present in every browser and in Node, so this
 * works in core without reaching for a DOM API.
 */
export function detectTimezone() {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone || undefined;
    }
    catch {
        return undefined;
    }
}
export function createDefaultPreferences() {
    return {
        user_id: 'default',
        // Whatever machine is creating these preferences is the user's. Wrapped
        // because a locked-down environment can throw, and a missing time zone is
        // recoverable while a crash at preference-creation is not.
        timezone: detectTimezone(),
        timezone_source: 'auto',
        work_hours: createDefaultWorkHours(),
        energy_patterns: createDefaultEnergyPatterns(),
        default_breaks: [],
        task_defaults: createDefaultTaskDefaults(),
        scheduling_preferences: createDefaultSchedulingPreferences(),
        display_preferences: createDefaultDisplayPreferences(),
        auto_reschedule_time: '22:00',
        auto_backup_time: '02:00',
    };
}
export function getWorkHoursForDay(preferences, dayName) {
    return preferences.work_hours[dayName.toLowerCase()] ?? { start: '08:00', end: '22:00' };
}
export function getEnergyPatternsForDay(preferences, dayName) {
    return preferences.energy_patterns[dayName.toLowerCase()] ?? [];
}
export function getEnergyLevelAtTime(preferences, dayName, timeStr) {
    const patterns = getEnergyPatternsForDay(preferences, dayName);
    const timeMinutes = timeToMinutes(timeStr);
    for (const block of patterns) {
        const blockStart = timeToMinutes(block.start);
        const blockEnd = timeToMinutes(block.end);
        // Handle overnight blocks (e.g., 21:00-06:00)
        if (blockEnd <= blockStart) {
            // Block spans midnight
            if (timeMinutes >= blockStart || timeMinutes < blockEnd) {
                return block.level;
            }
        }
        else {
            // Normal block
            if (timeMinutes >= blockStart && timeMinutes < blockEnd) {
                return block.level;
            }
        }
    }
    return null;
}
export function timeToMinutes(timeStr) {
    const parts = timeStr.split(':');
    return parseInt(parts[0], 10) * 60 + parseInt(parts[1], 10);
}
export function minutesToTime(minutes) {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return `${hours.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}`;
}
export function createDefaultSidebarPreferences() {
    return {
        visible: true,
        collapsedWidgets: [],
    };
}
export function createDefaultMoodBlocks() {
    return [
        { id: 'morning', name: 'Morning', start: '06:00', end: '12:00' },
        { id: 'afternoon', name: 'Afternoon', start: '12:00', end: '17:00' },
        { id: 'evening', name: 'Evening', start: '17:00', end: '21:00' },
        { id: 'night', name: 'Night', start: '21:00', end: '06:00' },
    ];
}
export function getCurrentMoodBlock(moodBlocks, timeStr) {
    const now = timeStr ? timeStr : `${new Date().getHours().toString().padStart(2, '0')}:${new Date().getMinutes().toString().padStart(2, '0')}`;
    const currentMinutes = timeToMinutes(now);
    for (const block of moodBlocks) {
        const blockStart = timeToMinutes(block.start);
        let blockEnd = timeToMinutes(block.end);
        // Handle overnight blocks (e.g., 21:00-06:00)
        if (blockEnd <= blockStart) {
            // Block spans midnight
            if (currentMinutes >= blockStart || currentMinutes < blockEnd) {
                return block;
            }
        }
        else {
            // Normal block
            if (currentMinutes >= blockStart && currentMinutes < blockEnd) {
                return block;
            }
        }
    }
    return null;
}
//# sourceMappingURL=preferences.js.map